<template>
  <div class="user-agreement-page">
    <div v-html="richText"></div>
  </div>
</template>

<script>
import requestApi from '@/service';

export default {
  data() {
    return {
      richText: '',
    };
  },
  activated() {
    this.getRichText();
  },
  methods: {
    getRichText() {
      requestApi('/v3/api/site/about/', {
        type: 2,
      }).then(res => {
        this.richText = res.content;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.user-agreement-page {
  padding: 30px;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
